import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {
    BaseSiteService,
    CmsService,
    OccEndpointsService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ResourcesService } from '../resources.service';
import { DownloadEmailSnackbarComponent } from './download-email-snackbar/download-email-snackbar.component';

@Component({
    selector: 'app-coding-education',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './coding-education.component.html',
    styleUrls: ['./coding-education.component.scss'],
    standalone: false
})
export class CodingEducationComponent implements OnInit, OnDestroy {
  totalPageCarousel: number = 0;
  currentPageCarousel: number = 0;
  filterAllSelect: boolean = false;
  filterSelected: string;
  docCategoryFilterList: any;
  docList: any;
  isLoggedIn$ = new Subject();
  cmsResponse: any;
  baseUrl: string;
  urlArr = [];
  strUrl: string = '';
  allDocSelected: boolean = false;
  currPage: number = 0;
  totalPages: number = 0;
  docPerPage: number = 0;
  totalDocuments: number = 0;
  pageSize: number = 9;
  baseSiteId: any;
  quickReimburseLinkCMS: any;
  crackingTheCodeStrainingCMS: any;
  hovered: boolean = false;
  baseSub: Subscription;
  resourceSub: Subscription;
  userSub: Subscription;
  cmsSub: Subscription;
  cmsSub2: Subscription;
  cmsSub3: Subscription;
  resourceSub2: Subscription;

  constructor(
    private readonly user: UserAccountFacade,
    private readonly resourceService: ResourcesService,
    private readonly router: Router,
    private readonly cmsData: CmsService,
    private readonly cd: ChangeDetectorRef,
    private readonly matSnackBar: MatSnackBar,
    private readonly occEndPoint: OccEndpointsService,
    private readonly baseSiteService: BaseSiteService
  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.userSub = this.user.get().subscribe((res) => {
      if (res !== undefined) {
        this.isLoggedIn$.next(true);
      } else {
        this.isLoggedIn$.next(false);
      }
    });
  }

  ngOnInit(): void {
    this.baseSub = this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.parseCmsData();
    this.getDocumentCategories();
    this.getDocumentList();
    this.getQuickLinkSection();
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
    this.cmsSub?.unsubscribe();
    this.cmsSub2?.unsubscribe();
    this.userSub?.unsubscribe();
    this.resourceSub?.unsubscribe();
  }

  goToReimburseSupport(url) {
    this.router.navigate([url]);
  }

  openLinkInNewWindow(url) {
    window.open(url);
  }

  getQuickLinkSection() {
    this.cmsSub = this.cmsData
      .getComponentData('SanofiQuickReimbursementSupportLink')
      .pipe(take(1))
      .subscribe((res) => {
        this.quickReimburseLinkCMS = res;
      });
    this.cmsSub2 = this.cmsData
      .getComponentData('CrackingTheCodeStraining')
      .pipe(take(1))
      .subscribe((res) => {
        this.crackingTheCodeStrainingCMS = res;
      });
  }

  hoverListItem(flag, doc) {
    if (doc?.selected) {
      doc['hovered'] = false;
    } else {
      doc['hovered'] = flag;
    }
  }

  hoverAllItem(flag, value) {
    if (value) {
      this.hovered = false;
    } else {
      this.hovered = flag;
    }
  }

  allSelected() {
    this.urlArr = [];
    this.allDocSelected = !this.allDocSelected;
    if (this.allDocSelected) {
      this.hovered = false;
      this.docList.forEach((element) => {
        element['selected'] = true;
        this.urlArr.push(this.baseUrl + element?.file?.downloadUrl);
      });
    } else {
      this.docList.forEach((element) => {
        element['selected'] = false;
      });
      this.urlArr = [];
    }
    if (this.urlArr.length > 0) {
      let obj = {
        docList: this.docList,
        selectedDocUrlList: this.urlArr,
      };
      this.matSnackBar.openFromComponent(DownloadEmailSnackbarComponent, {
        data: obj,
        panelClass: this.baseSiteId,
      });
    } else {
      this.matSnackBar.dismiss();
    }
  }

  addDownloadFooter(downloadUrl, index, doc) {
    this.hovered = false;
    this.docList[index]['selected'] = !this.docList[index]['selected'];
    if (downloadUrl) {
      this.strUrl = '';
      if (this.docList[index]['selected'] === false) {
        this.urlArr = this.urlArr.filter(
          (element) => element != this.baseUrl + downloadUrl
        );
      } else {
        this.urlArr.push(this.baseUrl + downloadUrl);
        this.urlArr = [...new Set(this.urlArr)];
      }
      this.urlArr.forEach((element, index) => {
        if (index <= this.urlArr.length - 1) {
          this.strUrl = this.strUrl + `window.open('${element}');`;
        }
      });
      this.allDocSelected = this.urlArr.length === 10 ? true : false;
      let obj = {
        docList: this.docList,
        selectedDocUrlList: this.urlArr,
      };
      if (this.urlArr.length > 0) {
        this.matSnackBar.openFromComponent(DownloadEmailSnackbarComponent, {
          data: obj,
          panelClass: this.baseSiteId,
        });
      } else {
        this.matSnackBar.dismiss();
      }
    }
  }

  paginationPrev() {
    this.currPage = this.currPage - 1;
    this.getDocumentList();
  }
  paginationNext() {
    this.currPage = this.currPage + 1;
    this.getDocumentList();
  }

  parseCmsData() {
    this.cmsSub3 = this.cmsData
      .getComponentData('FeatureResourceComponentOne')
      .subscribe((res) => {
        if (res) {
          this.cmsResponse = res;
        }
      });
  }

  getDocumentCategories() {
    const params = {
      enumerationType: 'DocumentCategoryEnum',
      fields: 'BASIC',
    };
    this.resourceService.getAllDocumentCategories(params);
    this.resourceSub2 = this.resourceService.documentCategoryList$.subscribe(
      (res) => {
        if (res !== undefined) {
          res.unshift({ code: 'ALL', name: 'All' });
          this.docCategoryFilterList = res;
          this.filterSelected = 'ALL';
          this.cd.markForCheck();
        }
      }
    );
  }

  getDocumentList() {
    const params = {
      fields: 'DEFAULT',
      currentPage: this.currPage,
      pageSize: this.pageSize,
    };
    this.resourceService.getAllDocuments(params, this.filterSelected);
    this.resourceSub = this.resourceService.documentList$.subscribe((res) => {
      if (res?.allDocuments !== undefined) {
        res?.allDocuments.map((element) => (element['selected'] = false));
        res?.allDocuments.map((element) => (element['hovered'] = false));
        this.docList = res?.allDocuments;
        this.docPerPage = res?.pagination?.pageSize;
        this.totalDocuments = res?.pagination?.totalResults;
        this.currPage = res?.pagination?.currentPage;
        this.totalPages = res?.pagination?.totalPages;
        this.cd.detectChanges();
      }
    });
  }
}
